import { Card, Chip, Divider, Stack, Typography, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import { UserFeedbackType, type UserFeedbackDto } from "src/http";

interface Props {
  feedback: UserFeedbackDto;
}

const UserFeedbackListItem = (props: Props) => {
  const theme = useTheme();

  return (
    <Card elevation={0} sx={{ border: `solid 1px ${theme.palette.line.main}`, p: { sm: 0.5, md: 1 } }}>
      <Stack>
        <Stack direction="row" spacing={0.5} sx={{ mb: 0.5 }}>
          {props.feedback.type === UserFeedbackType.Performance && (
            <Chip color="primary" label="Performance Feedback" />
          )}

          {props.feedback.type === UserFeedbackType.Peer && <Chip label="Peer To Peer Feedback" />}

          {props.feedback.type === UserFeedbackType.SelfReflection && <Chip label="Self-Reflection" />}

          {props.feedback.isReviewedByRecipient && (
            <Chip color="primary" variant="tertiary" label="Reviewed by Receipient" />
          )}

          {props.feedback.isReviewedInOneOnOne && <Chip color="primary" variant="tertiary" label="Reviewed in 1:1" />}

          {props.feedback.isDraft && <Chip color="secondary" label="Draft" />}
        </Stack>
        <Typography variant="h5">{props.feedback.title}</Typography>
        <Typography>From {props.feedback.givenByUser.displayName}</Typography>
        <Stack
          direction="row"
          spacing={0.5}
          divider={<Divider orientation="vertical" flexItem sx={{ height: "15px", alignSelf: "center" }} />}
        >
          <Typography variant="caption">Visible to Me, People Lead, People Ops</Typography>
          <Typography variant="caption">
            <span>Submitted </span>
            {DateTime.fromISO(props.feedback.submittedDateTimeUtc, { zone: "utc" })
              .toLocal()
              .toLocaleString(DateTime.DATE_MED)}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};

export { UserFeedbackListItem };
